<template>
  <Modal v-model="createLabelModal" width="500" :transfer="false" :mask-closable="false"
    :title="createLabelTitle" @on-visible-change="createLabelChange">
    <Form :model="createLabelForm" ref="createLabelForm" :rules="ruleValidate" :label-width="90" @submit.native.prevent>
      <Row style="width: 90%">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1003208')" prop="labelName">
            <Input v-model.trim="createLabelForm.labelName" :placeholder="$t('key1003209')">
            </Input>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1003210')" prop="remark">
            <Input v-model.trim="createLabelForm.remark" type="textarea" :autosize="{ minRows: 4, maxRows: 10}">
            </Input>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="createLabelModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="createLabelBtn">{{ $t('key1000555') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";

export default {
  name: "createLabelModal",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      createLabelModal: false,
      createLabelTitle: '',
      labelType: 'add',
      createLabelForm: {
        labelName: '',
        remark: ''
      },
      ruleValidate: {
        labelName: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003205'), trigger: 'blur'}
        ]
      },
      createLabelInfo: {},
    };
  },
  created() {

  },
  methods: {
    // 初始化数据
    initLabelData(type, data) {
      let titleObj = {
        add: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003206'),
        edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003207')
      };
      this.createLabelTitle = titleObj[type];
      this.labelType = type;
      if (data) {
        this.createLabelInfo = data;
        for (let key in this.createLabelForm) {
          this.createLabelForm[key] = data[key] || '';
        }
      }
      this.createLabelModal = true;
    },
    // 保存
    createLabelBtn() {
      let v = this;
      let methods = '';
      let url = '';
      let query = Object.assign({}, v.createLabelForm);
      if (v.labelType === 'add') {
        url = api.post_ymsDistributorLabel;
        methods = 'post';
      } else {
        url = api.put_ymsDistributorLabel_update;
        methods = 'put';
        query.type = v.createLabelInfo.type;
        query.ymsLabelId = v.createLabelInfo.ymsLabelId;
      }
      v.$refs['createLabelForm'].validate((valid) => {
        if (valid) {
          v.axios[methods](url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000705'));
              v.createLabelModal = false;
              v.$emit('updateData', true);
            }
          });
        }
      });
    },
    // 监听弹窗
    createLabelChange(value) {
      if (!value) {
        this.$refs['createLabelForm'].resetFields();
      }
    }
  }
};
</script>

<style lang="less" scoped>

</style>